import { render, staticRenderFns } from "./DoctorLoginLog.vue?vue&type=template&id=ca188ffc&scoped=true&"
import script from "./DoctorLoginLog.vue?vue&type=script&lang=js&"
export * from "./DoctorLoginLog.vue?vue&type=script&lang=js&"
import style1 from "./DoctorLoginLog.vue?vue&type=style&index=1&id=ca188ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca188ffc",
  null
  
)

export default component.exports